import React from "react";
import PropTypes from "prop-types";
import { useScript } from "react-recipes";
import { Paper, Typography } from "@material-ui/core";
import { RecurlyProvider, Elements } from "@recurly/react-recurly";

import { useSettings } from "hooks";
import LoaderSpinner from "components/LoaderSpinner";

import Title from "./components/Title";
import CurrentBillingInfo from "./components/CurrentBillingInfo";
import Recurly from "./components/Recurly";
import useStyles from "./useStyles";

const Form = (props) => {
  const { billingInfo, error, onSubscriptionChange, onSubscribe, isPending } = props;
  const classes = useStyles();
  const {
    settings: { recurlyApiKey },
  } = useSettings();
  const [recurlyLoaded, recurlyLoadError] = useScript("https://js.recurly.com/v4/recurly.js");

  if (!recurlyLoaded || recurlyLoadError) {
    return (
      <Typography variant="h3" align="center">
        Load Recurly API
      </Typography>
    );
  }
  return isPending ? (
    <LoaderSpinner />
  ) : (
    <>
      <Paper className={classes.content}>
        <RecurlyProvider publicKey={recurlyApiKey}>
          <Elements>
            <CurrentBillingInfo billingInfo={billingInfo} />
          </Elements>
        </RecurlyProvider>
      </Paper>

      <Paper className={classes.content}>
        <Title>Update Payment Info</Title>
        <RecurlyProvider publicKey={recurlyApiKey}>
          <Elements>
            <Recurly error={error} onSubscribe={onSubscribe} onSubscriptionChange={onSubscriptionChange} />
          </Elements>
        </RecurlyProvider>
      </Paper>
    </>
  );
};

Form.propTypes = {
  billingInfo: PropTypes.shape({}),
  error: PropTypes.string,
  isPending: PropTypes.bool.isRequired,
  onSubscribe: PropTypes.func.isRequired,
  onSubscriptionChange: PropTypes.func.isRequired,
};

export default Form;
